module.exports = __webpack_public_path__ + "img/1515887263.fc593cf4.jpg";